import * as React from 'react'
import { Box, Typography } from 'cs-kevlar-react'
import { DeviceLicenseEvents } from '../../../../api'

interface DeviceMigrationPlanProps {
  deviceLicenseEvents: DeviceLicenseEvents
}

export const DeviceMigrationPlan: React.FunctionComponent<DeviceMigrationPlanProps> = ({
  deviceLicenseEvents,
}) => {
  const hasDeviceEvents = deviceLicenseEvents.hasEvents
  const hasDeviceMovedEvents =
    deviceLicenseEvents.movedEvents?.length > 0 ?? false
  const hasDeviceRemovedEvents =
    deviceLicenseEvents.removedEvents?.length > 0 ?? false

  if (!hasDeviceEvents) return null

  return (
    <Box>
      <Typography>Device Changes</Typography>
      <ul>
        {hasDeviceMovedEvents &&
          deviceLicenseEvents.movedEvents.map((moveEvent, idx) => (
            <li key={`DeviceMoveEvents::${idx}`}>
              <li>
                <Typography>
                  {moveEvent.deviceLicense.name} moved to{' '}
                  {moveEvent.targetAgencyLicense.name} for{' '}
                  {moveEvent.deviceLicense.assignedUser?.name ??
                    'NO ASSIGNED USER'}
                </Typography>
              </li>
            </li>
          ))}
        {hasDeviceRemovedEvents &&
          deviceLicenseEvents.removedEvents.map((removeEvent, idx) => (
            <li key={`DeviceRemoveEvents::${idx}`}>
              <li>
                <Typography>
                  {removeEvent.deviceLicense.name} removed for{' '}
                  {removeEvent.deviceLicense.assignedUser?.name ??
                    'NO ASSIGNED USER'}
                </Typography>
              </li>
            </li>
          ))}
      </ul>
    </Box>
  )
}
